import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b3a5ade8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "footer"
};
const _hoisted_2 = {
  class: "links"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "友情链接", -1));

const _hoisted_4 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $data.links && $data.links.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.links, ({
    name,
    target_url,
    id
  }) => {
    return _openBlock(), _createElementBlock("a", {
      class: "nav",
      target: "_blank",
      href: target_url,
      key: id
    }, _toDisplayString(name), 9, _hoisted_4);
  }), 128))])])) : _createCommentVNode("", true);
}